import backendHttpClient from '@services/_httpClient/backend.http-client';
import { documentService } from '@services/documents/service';

import { type CreateCollaboratorPayload } from './dtos/create.dto';
import { type CollaboratorsRepository } from './repository';
import type {
  CreateCollaboratorBody,
  CreateCollaboratorResponse,
} from './types/create.type';
import type {
  GetCollaboratorStatementsOutput,
  GetCollaboratorStatementsParams,
  GetCollaboratorStatementsResponse,
} from './types/getStatements.type';

class CollaboratorService implements CollaboratorsRepository {
  public async create(payload: CreateCollaboratorPayload): Promise<void> {
    const documents: Array<{ url: string }> = [];
    for await (const file of payload.documents) {
      const { document } = await documentService.upload({
        file,
      });
      documents.push({ url: document.url });
    }
    await backendHttpClient.post<
      CreateCollaboratorResponse,
      CreateCollaboratorBody
    >({
      path: 'collaborators',
      body: {
        email: payload.email,
        name: payload.name,
        password: payload.password,
        phone: payload.phone,
        crm: payload.crm,
        document: payload.document,
        medical_specialties: payload.medicalSpecialties.map(specialty => ({
          medical_specialty_id: specialty.id,
          status: specialty.status,
        })),
        documents,
      },
    });
  }

  public async getStatements(
    params: GetCollaboratorStatementsParams,
  ): Promise<GetCollaboratorStatementsOutput> {
    const { data } = await backendHttpClient.get<
      GetCollaboratorStatementsResponse,
      GetCollaboratorStatementsParams
    >({
      path: `collaborators/statements`,
      params: {
        page: params.page,
      },
    });
    console.log({ data2: data });
    const output: GetCollaboratorStatementsOutput = {
      list: data.list.map(statement => ({
        id: statement.id,
        amount: statement.value,
        createdAt: statement.created_at,
        type: statement.type,
      })),
      pagination: {
        page: data.pagination.current || 1,
        totalPages: data.pagination.total,
      },
    };

    return output;
  }
}

export const collaboratorService = new CollaboratorService();
